// PAGES
import Login from "views/auth/login/page";
import ForgotMyPassword from "views/auth/forgot-password";
import Register from "views/auth/sign-up";
import TermsOfUse from "views/auth/terms-of-use";
import RecoverPassword from "views/auth/recover-password";
import ActivateUser from "views/auth/activate-user";
import VitrineVirtualClientes from "views/vitrine-virtual/page";
import NFe from "views/nfe/page";

import Home from "views/home/page";

// Dashboard
import DashboardSellIn from "views/dashboards/dashboard-sellin/page";
import DashboardIndicadoresDeAcesso from "views/dashboards/indicadores-acesso/page";
import { DashboardAcompanhamentoVisitas } from "views/dashboards/DashboardAcompanhamentoVisitas";
import { DashboardMonitorInfracommerce } from "views/dashboards/DashboardMonitorInfracommerce";
import DashboardOMNILojista from "views/dashboards/DashboardOMNILojista";
import DashboardIndicadoresConversao from "views/dashboards/DashboardIndicadoresConversao";
import DashboardMonitorPedidosPrateleiraInfinita from "views/dashboards/DashboardMonitorPedidosPrateleiraInfinita";
import { DashboardMonitorSenior } from "views/dashboards/DashboardMonitorSenior";
import FranchiseNetworkRanking from "views/dashboards/desempenho-franquias/RankingDaRede";
import MeusResultados from "views/dashboards/desempenho-franquias/MeusResultados";

// Clientes
import Lojista360 from "views/clientes/lojista-360/page";
import Consumidor360 from "views/clientes/consumidor-360/page";
import PainelEntrega from "views/clientes/painel-entrega/page";
import MeuCadastro from "views/clientes/meu-cadastro/page";

// Serviços
import SolicitacaoDevolucao from "views/servicos/solicitacao-devolucao/page";

// Produtos
import HistoricPrices from "views/produtos/historico-preco/page";
import FichaProduto from "views/produtos/ficha-produto/page";
import ProdutosDesejo from "views/produtos/produtos-desejo/page";
import MonitoramentoPreco from "views/produtos/monitoramento-preco/page";

// Pedidos
import RetireNaLoja from "views/pedidos/consulta-retire-loja/page";
import RelatorioPedidos from "views/pedidos/relatorio-pedidos/page";
import AtendimentosPrateleiraInfinita from "views/pedidos/AtendimentosPrateleiraInfinita";
import RelatorioApuracaoPrateleiraInfinita from "views/pedidos/RelatorioApuracaoPrateleiraInfinita";
import MapeamentoTriangularPrateleira from "views/pedidos/MapeamentoTriangularPrateleira";
import ConsultaPedidosOmni from "views/pedidos/ConsultaPedidosOmni";
import ConsultaPedidos from "views/pedidos/ConsultaPedidos";
import WorkFlowPI from "views/pedidos/WorkFlowPI";
import TrocasDevolucoes from "views/pedidos/TrocasDevolucoes";

// Vitrine B2B
import VisualizarVitrines from "views/vitrine-b2b/visualizar-vitrines/page";
import PublicarVitrine from "views/vitrine-b2b/publicar-vitrine/page";
import CriarVitrine from "views/vitrine-b2b/criar-vitrine/page";
import VitrineEmpresaPage from "views/vitrine-b2b/vitrine-empresa/page";

import ConsultaNotasFiscais from "views/notas-fiscais/consulta-nfs/page";
import RelatorioNotasFiscais from "views/notas-fiscais/relatorio-nfs/page";

// Estoque
import ProdutosSemVenda from "views/Estoque/SemVenda";
import RelatorioRecebimentoNFs from "views/Estoque/RelatorioRecebimentoNFs";
import ConsultaEstoque from "views/Estoque/ConsultaEstoque";
import RelatorioRecebimentoODs from "views/Estoque/RelatórioRecebimentoODs";

// Financeiro
import RelatorioAcompanhamentoTitulos from "views/Financeiro/acompanhamento-titulos/page";
import ExtratoServico from "views/Financeiro/extrato-servico/page";
import FundoPropaganda from "views/Financeiro/fundo-propaganda/page";

// Adm Franquias
import AdmTaxas from "views/adm-franquias/adm-taxas/page";
import GestaoCobranca from "views/adm-franquias/gestao-cobranca/page";
import GestaoFundoPropaganda from "views/adm-franquias/gestao-fundo-propaganda/page";

// Vendas
import MyVirtualShowcase from "views/vendas/minhas-vitrines/page";
import CriarVitrineVirtual from "views/vendas/criar-vitrine/page";
import VitrinesEnviadas from "views/vendas/vitrines-enviadas/page";

// Tecelagem
import MonitorTeares from "views/Tecelagem/MonitorTeares";
import MotivosDeFalha from "views/Tecelagem/MotivosDeFalha";
import RegistrarTearFalha from "views/Tecelagem/RegistrarTearFalha";

//Metas
import Metas from "views/metas/bonificacoes/page";
import MetasVendedores from "views/metas/vendedores/page";
import RelatorioPerformance from "views/metas/relatorio-performance/page";

// Administração
import ConfiguracoesTemplateOmnichat from "views/admin/configuracoes-omnichat/page";
import ConfiguracoesOmni from "views/admin/configuracoes-omni/page";
import Usuarios from "views/admin/Usuarios";
import Perfis from "views/admin/Perfis";
import Menus from "views/admin/Menus";
import DenyList from "views/admin/DenyList";
import LogsDeErro from "views/admin/LogsDeErro";
import Incidentes from "views/admin/Incidentes";
import ConfiguracaoIntegracoes from "views/admin/ConfiguracaoIntegracoes";
import PontoColetaVTEXLojista from "views/admin/PontoColetaVTEXLojista";
import { TrocaUsuario } from "views/admin/TrocaUsuario";
import FranquiasAdmPage from "views/admin/franquias-adm/page";

// Gerenciamento
import GerenciamentoSolicitacaoDevolucao from "views/gerenciamento/solicitacao-devolucao/page";
import MotivosDevolucao from "views/gerenciamento/motivos-devolucao/page";
import MotivosDefeito from "views/gerenciamento/motivos-defeito/page";
import GerenciamentoRecaptcha from "views/gerenciamento/GerenciamentoRecaptcha";
import ManutencaoInformacoesComplementares from "views/gerenciamento/ManutencaoInformacoesComplementares";
import GerenciamentoTermosAdesao from "views/gerenciamento/GerenciamentoTermosAdesao";
import { GerenciamentoReleaseNotes } from "views/gerenciamento/GerenciamentoReleaseNotes";
import { GerenciamentoRegrasComissao } from "views/gerenciamento/GerenciamentoRegrasComissao";
import GestaoCondicoesComerciais from "views/gerenciamento/GestaoCondicoesComerciais";

// Mobile
import BaixarAplicativo from "views/Mobile/BaixarAplicativo";

// Conteudo
import GestaoConteudo from "views/conteudo/gestao-conteudo/page";
import GerarLinkAWS from "views/conteudo/gerar-link-aws/page";
import CategoriasManuais from "views/conteudo/categorias-manuais/page";

// Governanca
import ImprovementForm from "views/Governanca/ImprovementForm";

// Serviços
import AcompanhamentoAtendimento from "views/servicos/acompanhamento-atendimento/page";

// Catalogo
import ImportacaoCatalogoProdutos from "views/catalogo-produtos/importacao-catalogo-produtos/page";
import VisualizarCatalogoProdutos from "views/catalogo-produtos/visualizar-catalogo-produtos/page";

// Operacoes
import ManuaisFranquias from "views/operacoes/manuais-franquias/page";
import GestaoFornecedoresHomologados from "views/operacoes/gestao-fornecedores-homologados/page";

// ICONS
import {
  AssignmentOutlined,
  MiscellaneousServices,
  AccountBalance,
  AccountBox,
  AddShoppingCart,
  AddTask,
  AddToPhotos,
  AllInclusive,
  AppSettingsAlt,
  AssignmentReturn,
  AttachMoney,
  AutoMode,
  BarChart,
  BrowserUpdated,
  BurstMode,
  Campaign,
  Category,
  Chat,
  Checklist,
  CloudSync,
  Construction,
  CurrencyExchange,
  Dashboard,
  Description,
  DeviceHub,
  DoDisturb,
  Download,
  Draw,
  Error,
  ErrorOutline,
  Favorite,
  FeedbackOutlined,
  FlagOutlined,
  ForestOutlined,
  Groups,
  HeadsetMic,
  HelpOutline,
  InfoOutlined,
  Inventory,
  Lan,
  Leaderboard,
  LocalAtm,
  LocalMall,
  LocalShipping,
  ManageAccounts,
  Map,
  Menu,
  MenuBook,
  MilitaryTech,
  MonetizationOn,
  NewReleasesOutlined,
  PeopleAlt,
  PermDataSettingOutlined,
  PersonSearch,
  PhoneIphone,
  PhotoLibrary,
  PinDrop,
  QrCode2,
  QueryStats,
  Receipt,
  ReceiptLong,
  Reply,
  RequestPageOutlined,
  RequestQuote,
  Settings,
  SettingsSuggest,
  ShoppingBag,
  ShoppingBasket,
  ShoppingCartCheckout,
  ShoppingCartOutlined,
  Shuffle,
  Store,
  Storefront,
  TrendingUp,
  Update,
  ViewInAr,
  Warning,
  BarChartSharp,
  SsidChartSharp,
  LeaderboardTwoTone,
  VerifiedUser,
  Money,
  ContentPasteSearch,
} from "@mui/icons-material";

const routeList = [
  {
    permissionKey: "Dashboard",
    defaultName: "Dashboard",
    icon: BarChart,
    iconColor: "Gray",
    state: "dashboardsCollapse",
    collapse: true,
    views: [
      {
        permissionKey: "DashboardSellIn",
        path: "/dashboard-sellin",
        defaultName: "Dashboard SellIn",
        icon: Dashboard,
        iconColor: "Success",
        component: DashboardSellIn,
        layout: "/admin",
      },
      {
        permissionKey: "DashboardOMNILojista",
        path: "/dashboard-omni-lojista",
        defaultName: "Dashboard OMNI Lojista",
        icon: Leaderboard,
        iconColor: "Success",
        component: DashboardOMNILojista,
        layout: "/admin",
      },
      {
        permissionKey: "DashboardAcompanhamentoVisitas",
        path: "/dashboard-acompanhamento-visitas",
        defaultName: "Dashboard Acompanhamento de Visitas",
        icon: BarChart,
        iconColor: "Success",
        component: DashboardAcompanhamentoVisitas,
        layout: "/admin",
      },
      {
        permissionKey: "DashboardIndicadoresConversao",
        path: "/indicadores-de-conversao",
        defaultName: "Indicadores de Conversão",
        icon: TrendingUp,
        iconColor: "Success",
        component: DashboardIndicadoresConversao,
        layout: "/admin",
      },
      {
        permissionKey: "LogsDeAcesso",
        path: "/indicadores-de-acesso",
        defaultName: "Indicadores de Acesso",
        icon: QueryStats,
        iconColor: "Success",
        component: DashboardIndicadoresDeAcesso,
        layout: "/admin",
      },
      {
        permissionKey: "MonitorPedidosPrateleiraInfinita",
        path: "/monitor-pedidos-prateleira-infinita",
        defaultName: "Monitor de Pedidos Prateleira Infinita",
        icon: CurrencyExchange,
        iconColor: "Success",
        component: DashboardMonitorPedidosPrateleiraInfinita,
        layout: "/admin",
      },
      {
        permissionKey: "MonitorInfracommerce",
        path: "/monitor-infracommerce",
        defaultName: "Monitor Infracommerce",
        icon: SettingsSuggest,
        iconColor: "Success",
        component: DashboardMonitorInfracommerce,
        layout: "/admin",
      },
      {
        permissionKey: "monitorSeniorSeta",
        path: "/monitor-senior-seta",
        defaultName: "Monitor Integração Seta x Senior",
        icon: CloudSync,
        iconColor: "Success",
        component: DashboardMonitorSenior,
        layout: "/admin",
      },
      {
        permissionKey: "DesempenhoFranquias",
        defaultName: "Desempenho Franquias",
        icon: BarChartSharp,
        iconColor: "Gray",
        state: "dashboardsCollapse",
        collapse: true,
        views: [
          {
            permissionKey: "RankingDaRede",
            path: "/ranking-da-rede",
            defaultName: "Ranking da Rede",
            icon: LeaderboardTwoTone,
            iconColor: "Success",
            component: FranchiseNetworkRanking,
            layout: "/admin",
          },
          {
            permissionKey: "MeusResultados",
            path: "/meus-resultados",
            defaultName: "Meus Resultados",
            icon: SsidChartSharp,
            iconColor: "Success",
            component: MeusResultados,
            layout: "/admin",
          },
        ],
      },
    ],
  },
  {
    permissionKey: "Clientes",
    defaultName: "Clientes",
    icon: Groups,
    iconColor: "Gray",
    state: "clientesCollapse",
    collapse: true,
    views: [
      {
        permissionKey: "MeuCadastro",
        path: "/meu-cadastro",
        defaultName: "Meu Cadastro",
        icon: ManageAccounts,
        iconColor: "Success",
        component: MeuCadastro,
        layout: "/admin",
      },
      {
        permissionKey: ["Lojista360", "Visao360"],
        path: "/lojista-360",
        defaultName: "Lojista 360",
        icon: AutoMode,
        iconColor: "Success",
        component: Lojista360,
        layout: "/admin",
      },
      {
        permissionKey: "Consumidor360",
        path: "/consumidor-360",
        defaultName: "Consumidor 360",
        icon: Storefront,
        iconColor: "Success",
        component: Consumidor360,
        layout: "/admin",
      },
      {
        permissionKey: "PainelEntrega",
        path: "/painel-entrega",
        defaultName: "Acompanhamento de Entrega",
        icon: LocalShipping,
        iconColor: "Success",
        component: PainelEntrega,
        layout: "/admin",
      },
    ],
  },
  {
    permissionKey: "PedidosVendas",
    defaultName: "Pedidos & Vendas",
    icon: ShoppingBasket,
    iconColor: "Gray",
    state: "pedidosVendasCollapse",
    collapse: true,
    views: [
      {
        permissionKey: "Pedidos",
        defaultName: "Pedidos de Sellin",
        icon: ShoppingBasket,
        iconColor: "Gray",
        layout: "/admin",
        state: "pedidosCollapse",
        collapse: true,
        views: [
          {
            permissionKey: "ConsultaDePedidos",
            path: "/consulta-de-pedidos",
            defaultName: "Consulta de Pedidos",
            icon: Checklist,
            iconColor: "Success",
            component: ConsultaPedidos,
            layout: "/admin",
          },
          {
            permissionKey: "orderReport",
            path: "/order-report",
            defaultName: "Relatório de Pedidos",
            icon: Description,
            iconColor: "Success",
            component: RelatorioPedidos,
            layout: "/admin",
          },
          {
            permissionKey: "VisualizarVitrines",
            path: "/visualizar-vitrines-b2b",
            defaultName: "Visualizar Vitrines B2B",
            icon: ShoppingCartOutlined,
            iconColor: "Success",
            component: VisualizarVitrines,
            layout: "/admin",
          },
          {
            permissionKey: "CriarVitrine",
            path: "/criar-vitrine-b2b",
            defaultName: "Criar Vitrine B2B",
            icon: AddShoppingCart,
            iconColor: "Success",
            component: CriarVitrine,
            layout: "/admin",
          },
          {
            permissionKey: "PublicarVitrine",
            path: "/publicar-vitrine-b2b",
            invisible: true,
            defaultName: "Publicar Vitrine B2B",
            iconColor: "Success",
            component: PublicarVitrine,
            layout: "/admin",
          },
        ],
      },
      {
        permissionKey: "Vendas",
        defaultName: "Vendas",
        icon: LocalAtm,
        iconColor: "Gray",
        layout: "/admin",
        state: "vendasCollapse",
        collapse: true,
        views: [
          {
            permissionKey: "AtendimentosPrateleiraInfinita",
            path: "/atendimentos-prateleira-infinita",
            defaultName: "Pedidos Prateleira Infinita",
            icon: AllInclusive,
            iconColor: "Success",
            component: AtendimentosPrateleiraInfinita,
            layout: "/admin",
          },
          {
            permissionKey: "RelatorioApuracaoPrateleiraInfinita",
            path: "/relatorio-apuracao-prateleira-infinita",
            defaultName: "Relatório de Apuração Prateleira Infinita",
            icon: ReceiptLong,
            iconColor: "Success",
            component: RelatorioApuracaoPrateleiraInfinita,
            layout: "/admin",
          },
          {
            permissionKey: "MapeamentoTriangularPrateleiraInfinita",
            path: "/mapeamento-triangular-prateleira-infinita",
            defaultName: "Mapeamento Triangular Prateleira Infinita",
            icon: Map,
            iconColor: "Success",
            component: MapeamentoTriangularPrateleira,
            layout: "/admin",
          },
          {
            permissionKey: "TrocasDevolucoes",
            path: "/trocas-devolucoes-prateleira-infinita",
            defaultName: "Trocas / Devoluções Prateleira infinita",
            icon: Shuffle,
            iconColor: "Success",
            component: TrocasDevolucoes,
            layout: "/admin",
          },
          {
            permissionKey: "WorkFlowPedidosPI",
            path: "/workflow-pedidos-prateleira-infinita",
            defaultName: "WorkFlow Prateleira Infinita",
            icon: DeviceHub,
            iconColor: "Success",
            component: WorkFlowPI,
            layout: "/admin",
          },
          {
            permissionKey: "VitrineVirtual",
            path: "/vitrine-virtual",
            defaultName: "Vitrine Virtual",
            icon: ShoppingCartOutlined,
            iconColor: "Success",
            component: MyVirtualShowcase,
            layout: "/admin",
          },
          {
            permissionKey: "CriarVitrineVirtual",
            path: "/nova-vitrine-virtual",
            defaultName: "Criar Vitrine Virtual",
            icon: AddShoppingCart,
            iconColor: "Success",
            component: CriarVitrineVirtual,
            layout: "/admin",
          },
          {
            permissionKey: "VitrineB2B",
            path: "/vitrine-virtual-b2b",
            defaultName: "Vitrine Virtual B2B",
            icon: Storefront,
            iconColor: "Success",
            component: VitrineEmpresaPage,
            layout: "",
          },
          {
            permissionKey: "VitrinesEnviadas",
            path: "/vitrines-enviadas",
            defaultName: "Vitrines Enviadas",
            icon: ShoppingCartCheckout,
            iconColor: "Success",
            component: VitrinesEnviadas,
            layout: "/admin",
          },
          {
            permissionKey: "ConsultaPedidosOmni",
            path: "/consulta-pedidos-omni",
            defaultName: "Consulta de Pedidos Omni",
            icon: Store,
            iconColor: "Success",
            component: ConsultaPedidosOmni,
            layout: "/admin",
          },
          {
            permissionKey: "RetireNaLoja",
            path: "/retire-na-loja",
            defaultName: "Consulta Retire na Loja",
            icon: LocalMall,
            iconColor: "Success",
            component: RetireNaLoja,
            layout: "/admin",
          },
        ],
      },
      {
        permissionKey: "LojasMetas",
        defaultName: "Lojas & Metas",
        icon: FlagOutlined,
        iconColor: "Gray",
        state: "lojasMetasCollapse",
        collapse: true,
        views: [
          {
            permissionKey: "ParametrizacaoMetas",
            path: "/goals-configuration",
            defaultName: "Parametrização de Metas",
            icon: MilitaryTech,
            iconColor: "Success",
            component: Metas,
            layout: "/admin",
          },
          {
            permissionKey: "metasVendedores",
            path: "/goals-sellers",
            defaultName: "Parametrização de Vendedores",
            icon: PeopleAlt,
            iconColor: "Success",
            component: MetasVendedores,
            layout: "/admin",
          },
          {
            permissionKey: "RelatorioPerformanceMetas",
            path: "/relatorio-performance-metas",
            defaultName: "Relatório Performance de Vendas",
            icon: TrendingUp,
            iconColor: "Success",
            component: RelatorioPerformance,
            layout: "/admin",
          },
        ],
      },
    ],
  },
  {
    permissionKey: "ProdutosCatalogo",
    defaultName: "Produtos & Catalogo",
    icon: ShoppingBag,
    iconColor: "Gray",
    state: "produtosCollapse",
    collapse: true,
    views: [
      {
        permissionKey: "FichaProduto",
        path: "/ficha-de-produto",
        defaultName: "Ficha de Produtos",
        icon: Description,
        iconColor: "Success",
        component: FichaProduto,
        layout: "/admin",
      },
      {
        permissionKey: "HistoricoDeAlteracaoDePrecos",
        path: "/historico-de-alteracao-de-precos",
        defaultName: "Histórico de Alteração de Preços",
        icon: AttachMoney,
        iconColor: "Success",
        component: HistoricPrices,
        layout: "/admin",
      },
      {
        permissionKey: "ProdutosDesejo",
        path: "/produtos-desejo",
        defaultName: "Produtos Desejo",
        icon: Favorite,
        iconColor: "Success",
        component: ProdutosDesejo,
        layout: "/admin",
      },
      {
        permissionKey: "acessoCatalogo",
        defaultName: "Acesse Catálogo Virtual",
        icon: BurstMode,
        iconColor: "Success",
        href: "https://www.karstensa.com.br/suporte/",
      },
      {
        permissionKey: "catalogoFotosProduto",
        path: "/catalogo-fotos-produto",
        defaultName: "Catálogo de Fotos do Produto",
        icon: AddToPhotos,
        iconColor: "Success",
        component: ImportacaoCatalogoProdutos,
        layout: "/admin",
      },
      {
        permissionKey: "visualizarCatalogoFotosProduto",
        path: "/visualizar-catalogo-fotos-produto",
        defaultName: "Visualizar Catálogo de Fotos do Produto",
        icon: PhotoLibrary,
        iconColor: "Success",
        component: VisualizarCatalogoProdutos,
        layout: "/admin",
      },
      {
        permissionKey: "monitoramentoPreco",
        path: "/monitoramento-preco",
        defaultName: "Monitoramento de Preços",
        icon: ContentPasteSearch,
        iconColor: "Success",
        component: MonitoramentoPreco,
        layout: "/admin",
      },
    ],
  },
  {
    permissionKey: "EstoqueNotasFiscais",
    defaultName: "Estoque & Notas Fiscais",
    icon: Inventory,
    iconColor: "Gray",
    state: "estoqueCollapse",
    collapse: true,
    views: [
      {
        permissionKey: "Estoque",
        defaultName: "Estoque",
        icon: Inventory,
        iconColor: "Gray",
        layout: "/admin",
        collapse: true,
        views: [
          {
            permissionKey: "ConsultaEstoque",
            path: "/consulta-estoque",
            defaultName: "Consulta Estoque",
            icon: ViewInAr,
            iconColor: "Success",
            component: ConsultaEstoque,
            layout: "/admin",
          },
          {
            permissionKey: "ProdutosSemVenda",
            path: "/produtos-sem-venda",
            defaultName: "Produtos Sem Venda",
            icon: Error,
            iconColor: "Success",
            component: ProdutosSemVenda,
            layout: "/admin",
          },
          {
            permissionKey: "RelatorioRecebimentoNFs",
            path: "/relatorio-recebimento-nfs",
            defaultName: "Relatório Recebimento de NFs",
            icon: Receipt,
            iconColor: "Success",
            component: RelatorioRecebimentoNFs,
            layout: "/admin",
          },
          {
            permissionKey: "RelatorioRecebimentoODs",
            path: "/relatorio-recebimento-ods",
            defaultName: "Relatório Recebimento de ODs",
            icon: ReceiptLong,
            iconColor: "Success",
            component: RelatorioRecebimentoODs,
            layout: "/admin",
          },
        ],
      },
      {
        permissionKey: "NotasFiscais",
        defaultName: "Notas Fiscais",
        icon: Receipt,
        iconColor: "Gray",
        layout: "/admin",
        collapse: true,
        views: [
          {
            permissionKey: "ConsultaNotasFiscais",
            path: "/consulta-notas-fiscais",
            defaultName: "Consulta de Notas Fiscais",
            icon: RequestQuote,
            iconColor: "Success",
            component: ConsultaNotasFiscais,
            layout: "/admin",
          },
          {
            permissionKey: "RelatorioNotasFiscais",
            path: "/relatorio-notas-fiscais",
            defaultName: "Relatório de Notas Fiscais",
            icon: ReceiptLong,
            iconColor: "Success",
            component: RelatorioNotasFiscais,
            layout: "/admin",
          },
        ],
      },
    ],
  },
  {
    permissionKey: "FinanceiroFranquias",
    defaultName: "Financeiro & Franquias",
    icon: MonetizationOn,
    iconColor: "Gray",
    state: "financeiroFranquiasCollapse",
    collapse: true,
    views: [
      {
        permissionKey: "Financeiro",
        defaultName: "Financeiro",
        icon: MonetizationOn,
        iconColor: "Gray",
        state: "financeiroCollapse",
        collapse: true,
        views: [
          {
            permissionKey: "RelatorioAcompanhamentoTitulos",
            path: "/relatorio-acompanhamento-titulos",
            defaultName: "Títulos Financeiros",
            icon: RequestPageOutlined,
            iconColor: "Success",
            component: RelatorioAcompanhamentoTitulos,
            layout: "/admin",
          },
          {
            permissionKey: "ExtratoServico",
            path: "/extrato-servico",
            defaultName: "Extrato de Serviço",
            icon: AttachMoney,
            iconColor: "Success",
            component: ExtratoServico,
            layout: "/admin",
          },
          {
            permissionKey: "FundoPropaganda",
            path: "/fundo-propaganda",
            defaultName: "Fundo de Propaganda",
            icon: Campaign,
            iconColor: "Success",
            component: FundoPropaganda,
            layout: "/admin",
          },
        ],
      },
      {
        permissionKey: "adm-franquias",
        defaultName: "Franquias",
        icon: Settings,
        iconColor: "Gray",
        state: "admFranquiasCollapse",
        collapse: true,
        views: [
          {
            permissionKey: "AdmTaxas",
            path: "/adm-taxas",
            defaultName: "Administração de Taxas",
            icon: RequestPageOutlined,
            iconColor: "Success",
            component: AdmTaxas,
            layout: "/admin",
          },
          {
            permissionKey: "gestaoCobrancas",
            path: "/gestao-cobrancas",
            defaultName: "Gestão de Cobranças",
            icon: AttachMoney,
            iconColor: "Success",
            component: GestaoCobranca,
            layout: "/admin",
          },
          {
            permissionKey: "GestaoFundoPropaganda",
            path: "/gestao-fundo-propaganda",
            defaultName: "Gestão de Fundo de Propaganda",
            icon: Campaign,
            iconColor: "Success",
            component: GestaoFundoPropaganda,
            layout: "/admin",
          },
        ],
      },
    ],
  },
  {
    permissionKey: "servicos",
    defaultName: "Serviços / Suprimentos",
    icon: MiscellaneousServices,
    iconColor: "Gray",
    state: "servicosSuprimentosCollapse",
    collapse: true,
    views: [
      {
        permissionKey: "trakcingServicesTickets",
        path: "/acompanhamento-atendimento",
        defaultName: "Acompanhamento de Atendimento",
        icon: AssignmentOutlined,
        iconColor: "Success",
        component: AcompanhamentoAtendimento,
        layout: "/admin",
      },
      {
        permissionKey: "solicitacaoDevolucao",
        path: "/solicitacao-devolucao",
        defaultName: "Solicitação de Devolucao",
        icon: Reply,
        iconColor: "Success",
        component: SolicitacaoDevolucao,
        layout: "/admin",
      },
    ],
  },
  {
    permissionKey: "Tecelagem",
    defaultName: "Tecelagem",
    icon: ForestOutlined,
    iconColor: "Gray",
    state: "tecelagemCollapse",
    collapse: true,
    views: [
      {
        permissionKey: "MonitorDeTeares",
        path: "/monitor-teares",
        defaultName: "Monitor de Teares",
        icon: Update,
        iconColor: "Success",
        component: MonitorTeares,
        layout: "/admin",
      },
      {
        permissionKey: "MotivosDeFalha",
        path: "/motivos-de-falha",
        defaultName: "Motivos de Falha",
        icon: FeedbackOutlined,
        iconColor: "Success",
        component: MotivosDeFalha,
        layout: "/admin",
      },
      {
        permissionKey: "RegistrarTearComFalha",
        path: "/registrar-tear-com-falha",
        defaultName: "Registrar Falha",
        icon: NewReleasesOutlined,
        iconColor: "Success",
        component: RegistrarTearFalha,
        layout: "/admin",
      },
    ],
  },
  {
    permissionKey: "GovernancaConfiguracoes",
    defaultName: "Governança & Configurações",
    icon: Construction,
    iconColor: "Gray",
    state: "governancaConfiguracoesCollapse",
    collapse: true,
    views: [
      {
        permissionKey: "AdminPortal",
        defaultName: "Administração",
        icon: Construction,
        iconColor: "Gray",
        state: "adminCollapse",
        collapse: true,
        views: [
          {
            permissionKey: "AdminPortalUsuario",
            path: "/usuarios",
            defaultName: "Usuários",
            icon: PeopleAlt,
            iconColor: "Success",
            component: Usuarios,
            layout: "/admin",
          },
          {
            permissionKey: "TrocaUsuario",
            path: "/troca-usuario",
            defaultName: "Troca de Usuário",
            icon: PersonSearch,
            iconColor: "Success",
            component: TrocaUsuario,
            layout: "/admin",
          },
          {
            permissionKey: "AdminPortalPerfil",
            path: "/perfis",
            defaultName: "Perfis",
            icon: AccountBox,
            iconColor: "Success",
            component: Perfis,
            layout: "/admin",
          },
          {
            permissionKey: "AdminPortalMenu",
            path: "/menus",
            defaultName: "Menus",
            icon: Menu,
            iconColor: "Success",
            component: Menus,
            layout: "/admin",
          },
          {
            permissionKey: "FranquiasAdm",
            path: "/franquias-adm",
            defaultName: "Administração de Franquia",
            icon: Store,
            iconColor: "Success",
            component: FranquiasAdmPage,
            layout: "/admin",
          },
          {
            permissionKey: "DenyList",
            path: "/deny-list",
            defaultName: "Deny List",
            icon: DoDisturb,
            iconColor: "Success",
            component: DenyList,
            layout: "/admin",
          },
          {
            permissionKey: "AdminPortalIncidentes",
            path: "/incidentes",
            defaultName: "Incidentes",
            icon: Warning,
            iconColor: "Success",
            component: Incidentes,
            layout: "/admin",
          },
          {
            permissionKey: "ConfiguracaoIntegracoes",
            path: "/configuracao-integracoes",
            defaultName: "Configuração de Integrações",
            icon: Lan,
            iconColor: "Success",
            component: ConfiguracaoIntegracoes,
            layout: "/admin",
          },
          {
            permissionKey: "OmniChatConfig",
            path: "/configuracao-template-omnichat",
            defaultName: "Configurações Template Omnichat",
            icon: Chat,
            iconColor: "Success",
            component: ConfiguracoesTemplateOmnichat,
            layout: "/admin",
          },
          {
            permissionKey: "ConfiguracoesOmni",
            path: "/configuracoes-omni",
            defaultName: "Configurações Omni",
            icon: AppSettingsAlt,
            iconColor: "Success",
            component: ConfiguracoesOmni,
            layout: "/admin",
          },
          {
            permissionKey: "AdminPortalPontoColetaVTEXLojista",
            path: "/ponto-coleta-vtex-lojista",
            defaultName: "Ponto de Coleta VTEX x Lojista",
            icon: PinDrop,
            iconColor: "Success",
            component: PontoColetaVTEXLojista,
            layout: "/admin",
          },
          {
            permissionKey: "LogsDeErro",
            path: "/logs-de-erro",
            defaultName: "Logs de Erro",
            icon: ErrorOutline,
            iconColor: "Success",
            component: LogsDeErro,
            layout: "/admin",
          },
        ],
      },
      {
        permissionKey: "Governanca",
        defaultName: "Governança TI",
        icon: AccountBalance,
        iconColor: "Gray",
        state: "governancaCollapse",
        collapse: true,
        views: [
          {
            permissionKey: "formularioMelhoria",
            path: "/formulario-melhoria",
            defaultName: "Formulário Melhoria",
            icon: MenuBook,
            iconColor: "Success",
            component: ImprovementForm,
            layout: "/admin",
          },
        ],
      },
    ],
  },
  {
    permissionKey: "GerenciamentoQualidade",
    defaultName: "Gerenciamento & Qualidade",
    icon: AddTask,
    iconColor: "Gray",
    state: "gerenciamentoQualidadeCollapse",
    collapse: true,
    views: [
      {
        permissionKey: "GerenciamentoRecaptcha",
        path: "/gerenciamento-recaptcha",
        defaultName: "Gerenciamento reCAPTCHA",
        icon: QrCode2,
        iconColor: "Success",
        component: GerenciamentoRecaptcha,
        layout: "/admin",
      },
      {
        permissionKey: "ReasonsReturn",
        path: "/motivos-devolucao",
        defaultName: "Motivos de Devoluções",
        icon: Reply,
        iconColor: "Success",
        component: MotivosDevolucao,
        layout: "/admin",
      },
      {
        permissionKey: "ReasonsDefect",
        path: "/motivos-defeito",
        defaultName: "Motivos de Defeito",
        icon: Reply,
        iconColor: "Success",
        component: MotivosDefeito,
        layout: "/admin",
      },
      {
        permissionKey: "SolicitacaoDevolucao",
        path: "/gestao-solicitacao-devolucao",
        defaultName: "Gestão de solicitação de devolução",
        icon: AssignmentReturn,
        iconColor: "Success",
        component: GerenciamentoSolicitacaoDevolucao,
        layout: "/admin",
      },
      {
        permissionKey: "ManutencaoInformacoesComplementares",
        path: "/manutencao-informacoes-complementares",
        defaultName: "Manutenção de Informações Complementares de Loja",
        icon: InfoOutlined,
        iconColor: "Success",
        component: ManutencaoInformacoesComplementares,
        layout: "/admin",
      },
      {
        permissionKey: "Termos de Adesão",
        path: "/gerenciamento-termos-adesao",
        defaultName: "Termos de Adesão",
        icon: Draw,
        iconColor: "Success",
        component: GerenciamentoTermosAdesao,
        layout: "/admin",
      },
      {
        permissionKey: "ReleaseNotes",
        path: "/gerenciamento-release-notes",
        defaultName: "Release Notes",
        icon: Description,
        iconColor: "Success",
        component: GerenciamentoReleaseNotes,
        layout: "/admin",
      },
      {
        permissionKey: "RegrasComissao",
        path: "/regras-de-comissao",
        defaultName: "Regras de Comissão",
        icon: Draw,
        iconColor: "Success",
        component: GerenciamentoRegrasComissao,
        layout: "/admin",
      },
      {
        permissionKey: "GestaoCondicoesComerciais",
        path: "/gestao-condicoes-comerciais",
        defaultName: "Vitrine B2B - Gestão de Condições Comerciais",
        icon: Money,
        iconColor: "Success",
        component: GestaoCondicoesComerciais,
        layout: "/admin",
      },
    ],
  },
  {
    permissionKey: "operacoes",
    defaultName: "Operações",
    icon: PermDataSettingOutlined,
    iconColor: "Gray",
    state: "operacoesCollapse",
    collapse: true,
    views: [
      {
        permissionKey: "manuaisFranquias",
        path: "/manuais-franquias",
        defaultName: "Conteúdo",
        icon: AssignmentOutlined,
        iconColor: "Success",
        component: ManuaisFranquias,
        layout: "/admin",
      },
      {
        permissionKey: "gestaoFornecedoresHomologados",
        path: "/gestao-fornecedores-homologados",
        defaultName: "Gestão Fornecedores Homologados",
        alternativeName: "Fornecedores Homologados",
        userPermissionToAlternativeName: "FRANQUEADO_VENDEDOR",
        icon: VerifiedUser,
        iconColor: "Success",
        component: GestaoFornecedoresHomologados,
        layout: "/admin",
      },
    ],
  },
  {
    permissionKey: "Conteudo",
    defaultName: "Conteúdo",
    icon: BrowserUpdated,
    iconColor: "Gray",
    state: "conteudoCollapse",
    collapse: true,
    views: [
      {
        permissionKey: "GestaoConteudo",
        path: "/gestao-conteudo",
        defaultName: "Gestão de Conteúdo",
        icon: MenuBook,
        iconColor: "Success",
        component: GestaoConteudo,
        layout: "/admin",
      },
      {
        permissionKey: "GerarLinkAWS",
        path: "/gerar-link-aws",
        defaultName: "Gerar Link AWS",
        icon: Description,
        iconColor: "Success",
        component: GerarLinkAWS,
        layout: "/admin",
      },
      {
        permissionKey: "CategoriasManuais",
        path: "/categorias-manuais",
        defaultName: "Categorias de Manuais",
        icon: Category,
        iconColor: "Success",
        component: CategoriasManuais,
        layout: "/admin",
      },
    ],
  },
  {
    permissionKey: "Mobile",
    defaultName: "Mobile",
    icon: PhoneIphone,
    iconColor: "Gray",
    state: "mobileCollapse",
    collapse: true,
    views: [
      {
        permissionKey: "BaixarAplicativo",
        path: "/baixar-aplicativo",
        defaultName: "Baixar Aplicativo",
        icon: Download,
        iconColor: "Success",
        component: BaixarAplicativo,
        layout: "/admin",
      },
    ],
  },
  {
    authRequired: false,
    defaultName: "Suporte",
    icon: HelpOutline,
    iconColor: "Gray",
    state: "suporteCollapse",
    collapse: true,
    views: [
      {
        authRequired: false,
        path: "/contact-us",
        defaultName: "Fale Conosco",
        icon: HeadsetMic,
        iconColor: "Success",
        component: () => (
          <iframe
            title="contact-us"
            style={{
              width: "100%",
              height: "85vh",
            }}
            src="https://cdn.atendimen.to/widget/4bc77d8ecf16f152563ae05a1ad46bd0/current"
          />
        ),
        layout: "/admin",
      },
      {
        authRequired: false,
        path: "/find-a-representant",
        defaultName: "Encontrar um Representante",
        icon: PersonSearch,
        iconColor: "Success",
        component: () => (
          <iframe
            title="find-representant"
            style={{
              width: "100%",
              height: "85vh",
            }}
            src="https://www.karstensa.com.br/sistema/lista-representantes.php"
          />
        ),
        layout: "/admin",
      },
    ],
  },
  {
    authRequired: false,
    collapse: true,
    defaultName: "Examples",
    state: "examplesCollapse",
    invisible: true,
    views: [
      {
        path: "/login",
        defaultName: "Login",
        component: Login,
        layout: "/auth",
      },
      {
        path: "/recover-password",
        defaultName: "Recover Password",
        component: RecoverPassword,
        layout: "/auth",
      },
      {
        path: "/forgot-my-password",
        defaultName: "Forgot My Password",
        component: ForgotMyPassword,
        layout: "/auth",
      },
      {
        path: "/sign-up",
        defaultName: "Create new account",
        component: Register,
        layout: "/auth",
      },
      {
        path: "/activate-user",
        defaultName: "Active new account",
        component: ActivateUser,
        layout: "/auth",
      },
      {
        path: "/termos-de-uso",
        defaultName: "Terms of Use",
        component: TermsOfUse,
        layout: "/auth",
      },
      { path: "/home", defaultName: "Home", component: Home, layout: "/" },
      {
        path: "/vitrine-virtual-cliente",
        defaultName: "Vitrine Virtual do Cliente",
        component: VitrineVirtualClientes,
        layout: "/",
      },
      // {
      //   path: "/vitrine-virtual-empresa",
      //   defaultName: "Vitrine Virtual da Empresa",
      //   component: VitrineEmpresaPage,
      //   layout: "/",
      // },
      {
        path: "/nfe",
        defaultName: "NF-e",
        component: NFe,
        layout: "/",
      },
    ],
  },
];

export default routeList;
